<template>
  <div>
    <div class="c-card-body">
      <!-- CARD: Generate Komisi -->
      <v-card class="mb-4" outlined>
        <v-card-title class="py-2">
          <v-icon class="mr-2">mdi-sync</v-icon>
          Generate Komisi Bulanan
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col md="4">
              <v-menu
                ref="monthMenu"
                v-model="monthMenu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="selectedMonth"
                    label="Pilih Bulan Generate Komisi"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    dense
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="selectedMonth"
                  type="month"
                  @input="monthMenu = false"
                  color="primary"
                ></v-date-picker>
              </v-menu>
            </v-col>

            <v-col md="3">
              <v-btn
                depressed
                class="ma-1"
                color="primary"
                small
                @click="generateCommission"
                :loading="loading"
              >
                <v-icon small left>mdi-sync</v-icon>
                Generate Komisi
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <datatable
        ref="datatable"
        module="commission-summary"
        :title="title"
        :url="url"
        :columns="columns"
        :disable-export="true"
        :action-width="180"
        :filter="[{ column: 'month', value: filterMonth }]"
      >
        <template v-slot:[`item.action`]="{ item }">
          <v-btn color="info" icon small @click="goToDetail(item)">
            <v-icon>mdi-eye</v-icon>
          </v-btn>
        </template>
        <template v-slot:action>
          <v-col md="4">
            <v-menu
              ref="filterMonthMenu"
              v-model="filterMonthMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="filterMonth"
                  label="Filter Bulan"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  dense
                  outlined
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filterMonth"
                type="month"
                @input="filterMonthMenu = false"
                color="primary"
              ></v-date-picker>
            </v-menu>
          </v-col>

          <v-col md="3">
            <v-btn
              depressed
              class="ma-1"
              color="success"
              small
              @click="onClickExport"
              :loading="loading"
            >
              <v-icon small left>mdi-file-download</v-icon>
              Export
            </v-btn>
          </v-col>
        </template>
        <template v-slot:[`item.total_sales`]="{ item }">
          <div>
            Rp {{ new Intl.NumberFormat("id-ID").format(item.total_sales) }}
          </div>
        </template>
        <template v-slot:[`item.total_session_sales`]="{ item }">
          <div>
            Rp {{ new Intl.NumberFormat("id-ID").format(item.total_session_sales) }}
          </div>
        </template>
        <template v-slot:[`item.total_class_sales`]="{ item }">
          <div>
            Rp
            {{ new Intl.NumberFormat("id-ID").format(item.total_class_sales) }}
          </div>
        </template>
        <template v-slot:[`item.dpp_sales`]="{ item }">
          <div>
            Rp {{ new Intl.NumberFormat("id-ID").format(item.dpp_sales) }}
          </div>
        </template>
        <template v-slot:[`item.dpp_sales_session`]="{ item }">
          <div>
            Rp {{ new Intl.NumberFormat("id-ID").format(item.dpp_sales_session) }}
          </div>
        </template>
        <template v-slot:[`item.commission_amount`]="{ item }">
          <div>
            Rp
            {{ new Intl.NumberFormat("id-ID").format(item.commission_amount) }}
          </div>
        </template>
        <template v-slot:[`item.incentive_amount`]="{ item }">
          <div>
            Rp
            {{ new Intl.NumberFormat("id-ID").format(item.incentive_amount) }}
          </div>
        </template>
        <template v-slot:[`item.conduct_fee`]="{ item }">
          <div>
            Rp {{ new Intl.NumberFormat("id-ID").format(item.conduct_fee) }}
          </div>
        </template>
         <template v-slot:[`item.progress_book_amount`]="{ item }">
          <div>
            Rp {{ new Intl.NumberFormat("id-ID").format(item.progress_book_amount) }}
          </div>
        </template>
        <template v-slot:[`item.neto_sales`]="{ item }">
          <div>
            Rp
            {{
              new Intl.NumberFormat("id-ID").format(
               item.neto_sales
              )
            }}
          </div>
        </template>
        <template v-slot:[`item.commission_rate`]="{ item }">
          <div>
            {{
               item.commission_rate              
            }}%
          </div>
        </template>
        <template v-slot:[`item.admin_fee`]="{ item }">
          <div>
            Rp
            {{
              new Intl.NumberFormat("id-ID").format(
               item.admin_fee
              )
            }}
          </div>
        </template>
        <template v-slot:[`item.admin_fee_session`]="{ item }">
          <div>
            Rp
            {{
              new Intl.NumberFormat("id-ID").format(
               item.admin_fee_session
              )
            }}
          </div>
        </template>
        <template v-slot:[`item.tax`]="{ item }">
          <div>
            Rp
            {{
              new Intl.NumberFormat("id-ID").format(
               item.tax
              )
            }}
          </div>
        </template>
        <template v-slot:[`item.tax_session`]="{ item }">
          <div>
            Rp
            {{
              new Intl.NumberFormat("id-ID").format(
               item.tax_session
              )
            }}
          </div>
        </template>
      </datatable>
      <v-dialog
        :key="selectedDetail?.id"
        v-model="showDetailModal"
        max-width="900px"
        scrollable
        persistent
      >
        <v-card>
          <v-card-title class="headline">
            Detail Komisi - {{ selectedDetail?.user_name || "-" }}
          </v-card-title>
          <v-card-text>
            <ListDetail
              v-if="selectedDetail"
              :id="selectedDetail.id"
              :user-name="selectedDetail.user_name"
              :month="selectedDetail.month"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="showDetailModal = false">
              Tutup
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Datatable from "@/view/component/Datatable.vue";
import ApiService from "@/core/services/api.service";
import moment from "moment";
import JwtService from "../../../../core/services/jwt.service";
import ListDetail from "./ListDetail.vue";

export default {
  components: { Datatable, ListDetail },
  data() {
    return {
      title: "Komisi",
      url: "commission-summary/data",
      loading: false,
      showDetailModal: false,
      selectedDetail: null,
      selectedMonth: moment().format("YYYY-MM"), // untuk generate
      filterMonth: moment().format("YYYY-MM"),
      filterMonthMenu: false,
      monthMenu: false,
      columns: [
        { value: "id" },
        { text: "month", value: "month", sortable: true, searchable: false },
        { text: "Nama", value: "user_name", sortable: true, searchable: true },
        { text: "Role", value: "role_name", sortable: true, searchable: true },
        { text: "Penjualan Membership", value: "total_sales", sortable: true },
        { text: "Penjualan Sesi", value: "total_session_sales", sortable: true },
        {
          text: "Penjualan Kelas",
          value: "total_class_sales",
          sortable: true,
        },
        { text: "Penjualan DPP", value: "dpp_sales", sortable: true },
        { text: "Penjualan DPP Sesi", value: "dpp_sales_session", sortable: true },
        { text: "Sesi Conduct", value: "total_checkin", sortable: true },
        { text: "Sales Rate", value: "commission_rate", sortable: true },
        { text: "Sales Komisi", value: "commission_amount", sortable: true },
        { text: "Incentive", value: "incentive_amount", sortable: true },
        { text: "Conduct Fee", value: "conduct_fee", sortable: true },
        {
          text: "Conduct Penalty",
          value: "conduct_penalty",
          sortable: true,
        },
        {
          text: "Progress Book",
          value: "progress_book_amount",
          sortable: true,
        },
        {
          text: "Pajak Paket Member",
          value: "tax",
          sortable: true,
          searchable: false,
        },
        {
          text: "Pajak Paket Sesi",
          value: "tax_session",
          sortable: true,
          searchable: false,
        },
        {
          text: "Biaya Admin Membership",
          value: "admin_fee",
          sortable: true,
          searchable: false,
        },
        {
          text: "Biaya Admin Sesi",
          value: "admin_fee_session",
          sortable: true,
          searchable: false,
        },
        {
          text: "Neto Sales",
          value: "neto_sales",
          sortable: true,
          searchable: false,
        },
        
      ],
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Manajemen Sales", route: "" },
      { title: "Komisi" },
    ]);
  },
  methods: {
    async goToDetail(item) {
      this.selectedDetail = item;
      this.showDetailModal = true;
    },
    async generateCommission() {
      try {
        const month = moment(this.selectedMonth).format("YYYY-MM");
        // const now = moment().startOf("month");
        // const selected = moment(this.selectedMonth, "YYYY-MM");

        // if (selected.isBefore(now)) {
        //   this.$swal.fire({
        //     icon: "error",
        //     title: "Bulan tidak valid",
        //     text: "Tidak dapat generate komisi untuk bulan sebelumnya.",
        //   });
        //   return;
        // }

        if (!month || !/^\d{4}-\d{2}$/.test(month)) {
          this.$swal.fire({
            icon: "error",
            title: "Bulan tidak valid",
            text: "Silakan pilih bulan dengan format benar (YYYY-MM)",
          });
          return;
        }

        // Langsung gabung query param ke URL
        const url = `sales/generate-commission?month=${encodeURIComponent(
          month
        )}`;
        await ApiService.get(url);

        this.$swal.fire({
          icon: "success",
          title: "Sukses",
          text: "Komisi berhasil digenerate",
          showConfirmButton: false,
          timer: 3000,
        });

        this.$refs.datatable.getData();
      } catch (error) {
        this.$swal.fire({
          icon: "error",
          title: "Gagal",
          text: "Gagal generate komisi",
        });
      }
    },
    async onClickExport() {
      try {
        if (!this.filterMonth) {
          this.$swal.fire({
            icon: "error",
            title: "Bulan tidak dipilih",
            text: "Silakan pilih bulan sebelum mengunduh laporan.",
          });
          return;
        }

        if (JwtService.getToken()) {
          const token = JwtService.getToken();
          var url =
            process.env.VUE_APP_SERVER_URL +
            "/commission-summary/export?token=" +
            token +
            "";
          if (this.filterMonth) {
            url = url + "&month=" + this.filterMonth;
          }
          window.open(url, "_blank");
        }
      } catch (e) {
        this.$swal.fire({
          icon: "error",
          title: "Gagal",
          text: "Gagal mengunduh laporan komisi.",
        });
      }
    },
  },
};
</script>

<style scoped>
.v-col {
  padding: 0 8px;
}
</style>
